webpackJsonp([373],{

/***/ 1797:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(67)(
  /* script */
  __webpack_require__(982),
  /* template */
  __webpack_require__(2388),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/home/runner/work/vux/vux/docs/node_modules/v-markdown-loader/_cache/v2.1.0-rc.46-196.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] v2.1.0-rc.46-196.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-8e5463c8", Component.options)
  } else {
    hotAPI.reload("data-v-8e5463c8", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ 2388:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("VUX V2.1.0Rc.46 发布日志")]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/button-tab.html"
    }
  }, [_vm._v("ButtonTab")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 添加更多`less`变量 #896 @erguotou520")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/datetime.html"
    }
  }, [_vm._v("Datetime")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 支持配置`取消`和`确定`的文字颜色 #715 @greedying")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/tab.html"
    }
  }, [_vm._v("Tab")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 支持设置 `bar-active-color` #715 @greedying")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/x-button.html"
    }
  }, [_vm._v("XButton")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 添加`less`变量 #896 @erguotou520")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/x-input.html"
    }
  }, [_vm._v("XInput")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 添加`slot=label`自定义label部分内容 #895 @erguotou520")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/x-number.html"
    }
  }, [_vm._v("XNumber")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] 使用`svg`代替 `+` `-` 字符")]), _vm._v(" "), _c('li', [_vm._v("[feature] 支持圆形按钮样式")])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-8e5463c8", module.exports)
  }
}

/***/ }),

/***/ 640:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1797);

/***/ }),

/***/ 982:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  head: { "title": "VUX V2.1.0Rc.46 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库", "ignoreSuffixChar": "|" }
});

/***/ })

});


// WEBPACK FOOTER //
// 373.a7d287ec.js